export interface IClpPriceLevel {
  price: number;
  volume: number;
}

export interface IClpClientSymbolParams {
  symbol: string;
  marketDepth: number;
}

export interface IClpLpSymbolParams {
  marketDepth: number;
  lpId: number;
  coreSymbolId: number;
}

export interface IClpLpSymbolRef {
  lpId: number;
  coreSymbolId: number;
}

export interface IClpPriceSubscriptionReq {
  requestId: string;
  clientSymbols: IClpClientSymbolParams[];
  lpSymbols: IClpLpSymbolParams[];
}

export interface IClpPriceSubscriptionRes {
  requestId: string;
  clientSymbols: string[];
  lpSymbols: IClpLpSymbolRef[];
}

export interface IClpPriceUnsubscriptionReq {
  requestId: string;
  clientSymbols: string[];
  lpSymbols: IClpLpSymbolRef[];
}

export interface IClpPriceUnsubscriptionRes {
  requestId: string;
}

export interface IClpSymbolQuoteEntry {
  symbol: string;
  bid: IClpPriceLevel[];
  ask: IClpPriceLevel[];
  timestamp: number;
}

export interface IClpLpQuoteEntry {
  lpId: number;
  coreSymbolId: number;
  bid: IClpPriceLevel[];
  ask: IClpPriceLevel[];
  timestamp: number;
}

export interface IClpSymbolPriceEvent {
  subscriptionRequestId: string;
  quotes: IClpSymbolQuoteEntry[];
}

export interface IClpLpPriceEvent {
  subscriptionRequestId: string;
  quotes: IClpLpQuoteEntry[];
}

export interface IClpError {
  requestId: string;
  errorCode: string;
  errorMessage: string;
}

/** Client → Server envelope (proto `ClpClientMessage`, `oneof body`). */
export interface IClpClientMessage {
  priceSubscription?: IClpPriceSubscriptionReq;
  priceUnsubscription?: IClpPriceUnsubscriptionReq;
}

/** Server → Client envelope (proto `ClpServerMessage`, `oneof body`). */
export interface IClpServerMessage {
  priceSubscription?: IClpPriceSubscriptionRes;
  priceUnsubscription?: IClpPriceUnsubscriptionRes;
  symbolPrice?: IClpSymbolPriceEvent;
  error?: IClpError;
  lpPrice?: IClpLpPriceEvent;
}

export enum ClpConnectionState {
  Idle = 'idle',
  Connecting = 'connecting',
  Open = 'open',
  Reconnecting = 'reconnecting',
  Closed = 'closed',
}
